import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ImagePreloadService {

  preload(urls: string[]): Promise<void> {
    const promises = urls.map(url => this.loadImage(url));
    return Promise.all(promises).then(() => undefined);
  }

  private loadImage(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => resolve(); // no bloquees la app por una imagen
      img.src = url;
    });
  }
}
